/*
 * @description:
 * @author: cuicui
 * @Date: 2023-01-19 23:17:21
 * @LastEditTime: 2025-08-19 16:12:30
 * @LastEditors: fusiyuan 1152054863@qq.com
 */
import Vue from "vue";
import Router from "vue-router";
import { oauthUrl, clientId, loginCallback, scope } from "./config/config";
import axios from "axios";
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  // mode: 'history',
  mode: "hash",
  routes: [
    {
      path: "/loginCallback",
      name: "loginCallback",
      component: () => import("./views/loginCallback/index.vue"),
      meta: { title: "用户登录" },
    },
    {
      path: "/",
      name: "index",
      component: () => import("./views/index/index.vue"),
      children: [
        {
          path: "/",
          name: "home",
          component: () => import("./views/home/index.vue"),
          meta: {
            title: "丝路版权网-后台管理",
          },
        },
        {
          path: "/messageCenter/message",
          name: "noticeIndex",
          component: () => import("./messageCenter/message/index.vue"),
          meta: {
            title: "丝路版权网-公告管理",
          },
        },
        {
          path: "/complaint",
          name: "complaint",
          component: () => import("./views/complaint"),
          meta: {
            title: "丝路版权网-投诉管理",
          },
        },
        {
          path: "/complaint/:id/shop",
          name: "complaintShop",
          component: () => import("./views/complaint/shop-detail"),
          meta: {
            title: "丝路版权网-投诉管理",
          },
        },
        {
          path: "/complaint/:id/goods",
          name: "complaintGoods",
          component: () => import("./views/complaint/goods-detail"),
          meta: {
            title: "丝路版权网-投诉管理",
          },
        },
        {
          path: "/suggestion",
          name: "suggestion",
          component: () => import("./views/suggestion/index.vue"),
          meta: {
            title: "丝路版权网-意见反馈",
          },
        },
        {
          path: "/suggestion/:id",
          name: "suggestionDetail",
          component: () => import("./views/suggestion/detail.vue"),
          meta: {
            title: "丝路版权网-意见反馈详情",
          },
        },
        {
          path: "/shop",
          name: "shop",
          component: () => import("./views/shop/index.vue"),
          meta: {
            title: "丝路版权网-店铺管理",
          },
        },
        {
          path: "/shop/:id/:subId",
          name: "shopDetail",
          component: () => import("./views/shop/detail.vue"),
          meta: {
            title: "丝路版权网-店铺详情",
          },
        },
        {
          path: "/withdraw",
          name: "withdraw",
          component: () => import("./views/withdraw"),
          meta: {
            title: "丝路版权网-提现管理",
          },
        },
        {
          path: "/withdraw/:id",
          name: "withdrawDetail",
          component: () => import("./views/withdraw/detail"),
          meta: {
            title: "丝路版权网-提现管理详情",
          },
        },
        {
          path: "/partner",
          name: "partner",
          component: () => import("./views/partner/index.vue"),
          meta: {
            title: "丝路版权网-合作商管理",
          },
        },
        {
          path: "/partnerDetail",
          name: "partnerDetail",
          component: () => import("./views/partner/partnerDetail.vue"),
          meta: {
            title: "丝路版权网-合作商管理",
          },
        },
        {
          path: "/users",
          name: "users",
          component: () => import("./views/users"),
          meta: {
            title: "丝路版权网-用户管理",
          },
        },
        {
          path: "/users/:id/:subId",
          name: "usersDetail",
          component: () => import("./views/users/detail"),
          meta: {
            title: "丝路版权网-用户详情",
          },
          redirect: "/users/:id/:subId/info",
          children: [
            {
              path: "/users/:id/:subId/info",
              name: "userDetailInfo",
              component: () => import("./views/users/children/_info"),
            },
            {
              path: "/users/:id/:subId/vertify",
              name: "userDetailVertify",
              component: () => import("./views/users/children/_vertify"),
            },
            {
              path: "/users/:id/:subId/order",
              name: "userDetailOrder",
              component: () => import("./views/users/children/_order"),
            },
            {
              path: "/users/:id/:subId/package",
              name: "userDetailPackage",
              component: () => import("./views/users/children/_package"),
            },
            {
              path: "/users/:id/:subId/charge",
              name: "userDetailCharge",
              component: () => import("./views/users/children/_charge"),
            },
          ],
        },
        {
          path: "/order",
          name: "order",
          component: () => import("./views/order/index.vue"),
          meta: {
            title: "丝路版权网-订单管理",
          },
        },
        {
          path: "/orderDetail",
          name: "orderDetail",
          component: () => import("./views/order/orderDetail/index.vue"),
          meta: {
            title: "丝路版权网-订单详情",
          },
        },
        {
          path: "/settlement",
          name: "settlement",
          component: () => import("./views/settlement/index.vue"),
          meta: {
            title: "丝路版权网-结算管理",
          },
        },
        {
          path: "/refund",
          name: "refund",
          component: () => import("./views/refund/index.vue"),
          meta: {
            title: "丝路版权网-退款管理",
          },
        },
        {
          path: "/refundDetail",
          name: "refundDetail",
          component: () => import("./views/refund/refundDetail/index.vue"),
          meta: {
            title: "丝路版权网-退款详情",
          },
        },
        {
          path: "/goodsReviewed",
          name: "goodsReviewed",
          component: () => import("./views/goodsReviewed/index.vue"),
          meta: {
            title: "丝路版权网-已审核商品",
          },
        },
        {
          path: "/goodsNotReviewed",
          name: "goodsNotReviewed",
          component: () => import("./views/goodsNotReviewed/index.vue"),
          meta: {
            title: "丝路版权网-待审核商品",
          },
        },
        {
          path: "/batchGoodsReviewed",
          name: "batchGoodsReviewed",
          component: () => import("./views/batchGoods/index.vue"),
          meta: {
            title: "丝路版权网-批量审核通道",
          },
        },
        {
          path: "/goodsDetail",
          name: "goodsDetail",
          component: () => import("./views/goodsDetail/index.vue"),
          meta: {
            title: "丝路版权网-商品详情",
          },
        },
        {
          path: "/works",
          name: "works",
          component: () => import("./views/works/index.vue"),
          meta: {
            title: "丝路版权网-作品管理",
          },
        },
        {
          path: "/worksDetail",
          name: "worksDetail",
          component: () => import("./views/worksDetail/index.vue"),
          meta: {
            title: "丝路版权网-作品详情",
          },
        },
        {
          path: "/echarts",
          name: "echarts",
          component: () => import("./views/echarts/index.vue"),
          meta: {
            title: "丝路版权网-业务数据",
          },
        },
        {
          path: "/role",
          name: "role",
          component: () => import("./views/role/index.vue"),
          meta: {
            title: "丝路版权网-角色管理",
          },
        },
        {
          path: "/administrators",
          name: "administrators",
          component: () => import("./views/administrators/index.vue"),
          meta: {
            title: "丝路版权网-管理员管理",
          },
        },
        // {
        // 	path: '/rights',
        // 	name: 'rights',
        // 	component: () => import('./views/rights/index.vue'),
        // 	meta: {
        // 		title: '丝路版权网-权益管理',
        // 	},
        // },
        {
          path: "/message",
          name: "message",
          component: () => import("./views/message/index.vue"),
          meta: {
            title: "丝路版权网-消息管理",
          },
        },
        {
          path: "/earnings",
          name: "earnings",
          component: () => import("./views/earnings/index.vue"),
          meta: {
            title: "丝路版权网-收益管理",
          },
        },
        {
          path: "/notice",
          name: "notice",
          component: () => import("./views/notice/index.vue"),
          meta: {
            title: "丝路版权网-公告管理",
          },
        },
        {
          path: "/evaluate",
          name: "evaluate",
          component: () => import("./views/evaluate/index.vue"),
          meta: {
            title: "丝路版权网-评价管理",
          },
        },
        {
          path: "/evaluateDetail",
          name: "evaluateDetail",
          component: () => import("./views/evaluate/evaluateDetail/index.vue"),
          meta: {
            title: "丝路版权网-后台管理",
          },
        },
        {
          path: "/agreement",
          name: "agreement",
          component: () => import("./views/agreement/index.vue"),
          meta: {
            title: "丝路版权网-协议管理",
          },
        },
        {
          path: "/goodsType",
          name: "goodsType",
          component: () => import("./views/goodsType/index.vue"),
          meta: {
            title: "丝路版权网-商品类型管理",
          },
        },
        {
          path: "/backstageClass",
          name: "backstageClass",
          component: () => import("./views/backstageClass/index.vue"),
          meta: {
            title: "丝路版权网-后台商品分类",
          },
        },
        {
          path: "/receptionClass",
          name: "receptionClass",
          component: () => import("./views/receptionClass/index.vue"),
          meta: {
            title: "丝路版权网-前台商品分类",
          },
        },
        {
          path: "/addReceptionClass",
          name: "addReceptionClass",
          component: () => import("./views/addReceptionClass/index.vue"),
          meta: {
            title: "丝路版权网-新增前台商品分类",
          },
        },
        {
          path: "/goodsAttribute",
          name: "goodsAttribute",
          component: () => import("./views/goodsAttribute/index.vue"),
          meta: {
            title: "丝路版权网-商品属性管理",
          },
        },
        {
          path: "/priceAttribute",
          name: "priceAttribute",
          component: () => import("./views/priceAttribute/index.vue"),
          meta: {
            title: "丝路版权网-定价属性管理",
          },
        },
        {
          path: "/article",
          name: "article",
          component: () => import("./views/article/index.vue"),
          meta: {
            title: "丝路版权网-文章管理",
          },
        },
        {
          path: "/journal",
          name: "journal",
          component: () => import("./views/journal/index.vue"),
          meta: {
            title: "丝路版权网-系统日志",
          },
        },
        {
          path: "/mallAdministration",
          name: "mallAdministration",
          component: () => import("./views/mallAdministration/index.vue"),
          meta: {
            title: "丝路版权网-平台商城管理",
          },
        },
        {
          path: "/dictionary",
          name: "dictionary",
          component: () => import("./views/dictionary/index.vue"),
          meta: {
            title: "丝路版权网-字典表管理",
          },
        },
        {
          path: "/esReset",
          name: "esReset",
          component: () => import("./views/esReset/index.vue"),
          meta: {
            title: "丝路版权网-es资源重置",
          },
        },
        {
          path: "/general",
          name: "general",
          component: () => import("./views/general/index.vue"),
          meta: {
            title: "丝路版权网-普通版权管理",
          },
        },
        {
          path: "/general/detail",
          name: "generalDetail",
          component: () => import("./views/general/detail.vue"),
          meta: {
            title: "丝路版权网-普通版权详情",
          },
        },
        {
          path: "/digitalRights",
          name: "digitalRights",
          component: () => import("./views/digitalRights/index.vue"),
          meta: {
            title: "丝路版权网-数字版权管理",
          },
        },
        {
          path: "/digitalRights/:id/:action",
          name: "digitalRightsDetail",
          component: () => import("./views/digitalRights/detail.vue"),
          meta: {
            title: "丝路版权网-数字版权详情",
          },
        },
        {
          path: "/copyrightProtection",
          name: "copyrightProtection",
          component: () => import("./views/copyrightProtection/index.vue"),
          meta: {
            title: "丝路版权网-版权维权管理",
          },
        },
        {
          path: "/copyrightProtection/detail",
          name: "copyrightProtectionDetail",
          component: () => import("./views/copyrightProtection/detail.vue"),
          meta: {
            title: "丝路版权网-版权维权详情",
          },
        },
        {
          path: "/bill",
          name: "bill",
          component: () => import("./views/bill/index.vue"),
          meta: {
            title: "丝路版权网-发票管理",
          },
        },
        {
          path: "/bill/detail",
          name: "billDetail",
          component: () => import("./views/bill/detail.vue"),
          meta: {
            title: "丝路版权网-发票详情",
          },
        },
        {
          path: "/imageNode",
          name: "imageNode",
          component: () => import("./views/pageMa/imageNode.vue"),
          meta: {
            title: "标签管理",
          },
        },
        {
          path: "/imageCategory",
          name: "imageCategory",
          component: () => import("./views/pageMa/imageCategory.vue"),
          meta: {
            title: "分类管理",
          },
        },
        {
          path: "/holidayHot",
          name: "holidayHot",
          component: () => import("./views/pageMa/holidayHot.vue"),
          meta: {
            title: "节庆热点",
          },
        },
        {
          path: "/carouselMap",
          name: "carouselMap",
          component: () => import("./views/pageMa/carouselMap.vue"),
          meta: {
            title: "轮播图",
          },
        },
        {
          path: "/showSetting",
          name: "showSetting",
          component: () => import("./views/pageMa/showSetting.vue"),
          meta: {
            title: "展示设置",
          },
        },
        {
          path: "/consultingManagement",
          name: "consultingManagement",
          component: () => import("./views/consultingManagement/index.vue"),
          meta: {
            title: "咨询管理",
          },
        },
        {
          path: "/packageSetting",
          name: "packageSetting",
          component: () => import("./views/packageManage/index.vue"),
          meta: {
            title: "套餐设置",
          },
        },
        {
          path: "/contractManagement",
          name: "contractManagement",
          component: () => import("./views/contractManagement/index.vue"),
          meta: {
            title: "签约管理",
          },
        },
        {
          path: "/contractManagement/:id",
          name: "detailPage",
          component: () => import("./views/contractManagement/detailPage.vue"),
          meta: {
            title: "签约详情",
          },
        },
        {
          path: "/resourceUpload",
          name: "resourceUpload",
          component: () =>
            import("./views/contractManagement/resourceUpload.vue"),
          meta: {
            title: "资源代传",
          },
        },
        {
          path: "/listWorks",
          name: "listWorks",
          component: () => import("./views/listWorks/index.vue"),
          meta: {
            title: "作品列表",
          },
        },
        {
          path: "/listWorks/:id/:type",
          name: "detailsView",
          component: () => import("./views/listWorks/detailsView.vue"),
          meta: {
            title: "作品详情",
          },
        },
        {
          path: "/KBManage",
          name: "KBManage",
          component: () => import("./views/KBManage/index.vue"),
          meta: {
            title: "知识库管理",
          },
        },
        {
          path: "/KBManage/:id/:type",
          name: "detailsKBView",
          component: () => import("./views/KBManage/detailsView.vue"),
          meta: {
            title: "知识库详情",
          },
        },
        {
          path: "/customPackage",
          name: "customPackage",
          component: () => import("./views/customPackage/index.vue"),
          meta: {
            title: "定制套餐",
          },
        },
        {
          path: "/agencyPackage",
          name: "agencyPackage",
          component: () => import("./views/customPackage/agency.vue"),
          meta: {
            title: "代理套餐",
          },
        },
        {
          path: "/imageOrder",
          name: "imageOrder",
          component: () => import("./views/payManagement/imageOrder/index.vue"),
          meta: {
            title: "订单列表",
          },
        },
        {
          path: "/imageOrderDetail",
          name: "imageOrderDetail",
          component: () =>
            import("./views/payManagement/imageOrder/orderDetail/index.vue"),
          meta: {
            title: "订单列表-详情",
          },
        },
        {
          path: "/packagePay",
          name: "packagePay",
          component: () => import("./views/payManagement/packagePay/index.vue"),
          meta: {
            title: "套餐购买",
          },
        },
        {
          path: "/packagePayDetail",
          name: "packagePayDetail",
          component: () =>
            import("./views/payManagement/packagePay/detail/index.vue"),
          meta: {
            title: "套餐购买-详情",
          },
        },
        {
          path: "/rechargeRecord",
          name: "rechargeRecord",
          component: () =>
            import("./views/payManagement/rechargeRecord/index.vue"),
          meta: {
            title: "充值记录",
          },
        },
        {
          path: "/rechargeRecordDetail",
          name: "rechargeRecordDetail",
          component: () =>
            import("./views/payManagement/rechargeRecord/detail/index.vue"),
          meta: {
            title: "充值记录-详情",
          },
        },
        {
          path: "/packageConsumption",
          name: "packageConsumption",
          component: () =>
            import("./views/payManagement/packageConsumption/index.vue"),
          meta: {
            title: "套餐消费",
          },
        },
        {
          path: "/countryConsumption",
          name: "countryConsumption",
          component: () =>
            import("./views/payManagement/countryConsumption/index.vue"),
          meta: {
            title: "国版币消费",
          },
        },
        {
          path: "/countryIssue",
          name: "countryIssue",
          component: () =>
            import("./views/payManagement/countryIssue/index.vue"),
          meta: {
            title: "国版币发放",
          },
        },
      ],
      meta: {
        title: "丝路版权网-后台管理",
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  /* console.log('测试接口调用')
	axios.get('http://192.168.10.139:9090/manage/categorize/page')
  		.then(response => {
   	 console.log(response.data.data);
  		})
  		.catch(error => {
    console.error(error);
  		}); */
  const token = sessionStorage.getItem("token");
  let url = window.location.href;
  if (token) {
    next();
  } else {
    if (url.indexOf("access_token") > -1) {
      sessionStorage.setItem("token", url.split("&")[0].split("=")[1]);
      sessionStorage.setItem("token_type", url.split("&")[1].split("=")[1]);
      sessionStorage.setItem("state", url.split("&")[2].split("=")[1]);
      sessionStorage.setItem("expires_in", url.split("&")[3].split("=")[1]);
      sessionStorage.setItem("jti", url.split("&")[4].split("=")[1]);
      next({
        path: "/loginCallback",
      });
    } else {
      sessionStorage.setItem("jumpRouter", to.fullPath);
      setTimeout(function() {
        window.location =
          oauthUrl +
          "/oauth/authorize?" +
          encodeURI(
            "client_id=" +
              clientId +
              "&response_type=token&state=5ca75bd30&scope=" +
              scope +
              "&redirect_uri=" +
              loginCallback
          );
      }, 500);
    }
  }
});

router.afterEach((to) => {
  document.title = to.meta.title || "丝路版权网-后台管理";
});
export default router;
